function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = require("react");

var styled = require("styled-components").default;

var Link = require("@patternplate/component-link").Link;

var Icon = require("@patternplate/component-icon").Icon;

var StyledLink = styled(Link).withConfig({
  displayName: "logo__StyledLink"
})(["display:block;margin:0 auto;&:link,&:visited{color:", ";}"], function (props) {
  return props.theme.colors.active;
});

var Logo =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Logo, _React$Component);

  function Logo() {
    _classCallCheck(this, Logo);

    return _possibleConstructorReturn(this, (Logo.__proto__ || Object.getPrototypeOf(Logo)).apply(this, arguments));
  }

  _createClass(Logo, [{
    key: "render",
    value: function render() {
      var props = this.props;

      if (props.source) {
        return React.createElement("div", {
          className: props.className
        }, React.createElement(StyledLink, {
          external: "base",
          href: "/",
          query: null,
          target: "_self"
        }, React.createElement("div", {
          dangerouslySetInnerHTML: {
            __html: props.source
          }
        })));
      }

      return React.createElement("div", {
        className: props.className
      }, React.createElement(StyledLink, {
        external: "base",
        href: "/",
        query: null,
        target: "_self"
      }, React.createElement(Icon, {
        symbol: "patternplate",
        size: "l"
      })));
    }
  }]);

  return Logo;
}(React.Component);

var StyledLogo = styled(Logo).withConfig({
  displayName: "logo__StyledLogo"
})(["box-sizing:border-box;display:flex;width:100%;fill:currentColor;stroke:currentColor;stroke-width:0;align-items:center;padding:10px;background:", ";"], function (props) {
  return props.theme.colors.backgroundSecondary;
});

module.exports = function (props) {
  return React.createElement(StyledLogo, props);
};
//# sourceMappingURL=logo.js.map